import React from 'react';
import {
  Typography, CardMedia,
  Button, CardBody, CardActions, Card, CardContent, CardTitle
} from '@one-thd/sui-atomic-components';
import fallbackViewTexts from '../../constants/fallbackViewTexts';
import { showAboveSmBreakpoint, showBelowSmBreakpoint } from '../../constants/responsiveClassNames';

const {
  benefits, learnMoreText, cardTitle, cardTitleMobile,
  imageUrl, imageAlt,
} = fallbackViewTexts;

const QuotesFallbackView = () => (
  <>
    <div className={showAboveSmBreakpoint}>
      <Card orientation="horizontal">
        <CardContent disablePadding initialSize="2/4">
          <CardTitle
            header={cardTitle}
            headerWeight="bold"
          />
          <CardBody>
            <Typography>
              <div className="sui-my-4">
                <ul className="sui-list-disc sui-list-inside sui-px-2">
                  {benefits.map((benefit, index) => (
                    <li key={index}>{benefit}</li>
                  ))}
                </ul>
              </div>
            </Typography>
          </CardBody>
          <CardActions>
            <Button variant="secondary">{learnMoreText}</Button>
          </CardActions>
        </CardContent>
        <CardContent orientation="horizontal" disablePadding initialSize="2/4">
          <CardMedia src={imageUrl} alt={imageAlt} aspect="wide" />
        </CardContent>
      </Card>
    </div>

    <div className={showBelowSmBreakpoint}>
      <Card disablePadding disableGutters className="sui-mt-4">
        <CardContent disablePadding>
          <CardMedia src={imageUrl} alt={imageAlt} aspect="wide" />
        </CardContent>
        <CardContent>
          <CardTitle header={cardTitleMobile} headerWeight="display" />
          <CardBody>
            <Typography>
              <div className="sui-my-4">
                <ul className="sui-list-disc sui-list-inside sui-px-2">
                  {benefits.map((benefit, index) => (
                    <li key={index}>{benefit}</li>
                  ))}
                </ul>
              </div>
            </Typography>
          </CardBody>
          <CardActions>
            <Button fullWidth variant="secondary">{learnMoreText}</Button>
          </CardActions>
        </CardContent>
      </Card>
    </div>
  </>
);

export default QuotesFallbackView;